<template>
  <el-row class="TalentCenter" v-loading="listLoading">
    <div class="resume-top">
      <div class="resume-top-left">
        <span
          :class="selectTabTotal === item.status ? 'rtl-select' : ''"
          v-for="item in tabTotal"
          :key="item.status"
          @click="switchTabTotal(item.status)"
          >{{ totalName[item.status] }}</span
        >
      </div>
    </div>
    <div class="resume-top-title" v-if="selectTabTotal == 0">
      <div>
        <span
          >人才库展示上限：{{
            talent_pool_limit < 0 ? "全部" : talent_pool_limit
          }}</span
        >
        <span>今日剩余邀投：{{ invite_deliver_today_surplus }}次</span>
        <span>剩余简历下载：{{ resume_download_num_surplus }}份</span>
      </div>
      <span @click="more">获取更多>></span>
    </div>

    <div class="last-box">
      <div class="last-box-top-left" v-if="selectTabTotal == 0">
        已为您找到 {{ listTotal }} 名候选人才
      </div>
      <div class="last-box-top-left" v-if="selectTabTotal == 1">
        已收藏 {{ listTotal }} 名候选人才
      </div>
      <div class="last-box-top-left" v-if="selectTabTotal == 2">
        近30天已下载 {{ listTotal }} 名候选人才简历，可免费重下人才最新简历
      </div>
      <div
        class="filter-btn"
        @click="openRightFilter"
        :class="filterColor.color"
      >
        <img
          v-if="filterColor.img === 1"
          :src="require('$img/filter-select-icon.png')"
          alt=""
        />
        <img
          v-if="filterColor.img === 0"
          :src="require('$img/filter-icon.png')"
          alt=""
        />
        <div>筛选</div>
      </div>
    </div>
    <div
      class="index-content"
      :style="
        selectTabTotal == 0
          ? 'height: calc(100% - 183px)'
          : 'height: calc(100% - 143px)'
      "
    >
      <TalentCenterListItem
        from="option"
        v-for="item in resumeList"
        ref="talentCenter"
        :key="item.id"
        :resData="item"
        :selectTab="selectTabTotal"
        :invite_deliver_today_surplus="invite_deliver_today_surplus"
        :resume_download_num_surplus="resume_download_num_surplus"
        :filterRef="otherFilter"
        @openDetail="openDetailMod"
        @invite="invite"
        @resDatad="resDatad"
      ></TalentCenterListItem>
      <NoData
        :title="
          selectTabTotal === 0 ? '暂无相关人才简历哦~' : '暂无相应人才简历'
        "
        :message="
          selectTabTotal === 0
            ? '发布招聘中的职位，才能为您推荐相关人才哦'
            : '先去人才库挑选一下吧'
        "
        :router="selectTabTotal === 0 ? '/Management/staff' : false"
        :btTitle="selectTabTotal === 0 ? '前往职位管理' : false"
        v-if="!listLoading && resumeList.length === 0"
      ></NoData>
    </div>
    <div class="page-view">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30]"
        :current-page.sync="listPage"
        :page-size.sync="listSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <resumeDisablog
      ref="dialogComponent"
      @updateStatus="updateListData"
      from="talent"
      :dataList="dataList"
      @close="close"
      @inviteDia="inviteDia"
    ></resumeDisablog>
    <RightFilter
      showWant="1"
      ref="rFilter"
      :filterRef="otherFilter"
      @getFilter="getFilterData"
      type="TalentCenter"
    ></RightFilter>
    <el-dialog
      title=""
      :visible.sync="inviteDialog"
      width="500px"
      heigth="302px"
      class="inviteDialog"
    >
      <div>
        <div class="inviteDialog-top">
          <div class="inviteDialog-img">
            <el-image
              v-if="resData.head_logo"
              :src="resData.head_logo"
              alt=""
              fit="cover"
            ></el-image>
          </div>
          <div class="inviteDialog-right">
            <div class="inviteDialog-right-top">
              <span>{{ resData.name }}</span>
              <button v-if="dynamic <= 1">今日活跃</button>
              <button v-else-if="dynamic <= 7">本周活跃</button>
              <button v-else-if="dynamic <= 30">月内活跃</button>
            </div>
            <div class="inviteDialog-right-center" v-if="type == 1">
              {{ resData.work_age ? `工作${resData.work_age}年` : "无工作经验"
              }}<span>|</span>{{ resData.education }}<span>|</span
              >{{ resData.age }}岁<span>|</span>{{ resData.gender ? "男" : "女"
              }}<span>|</span>{{ resData.height }}cm
            </div>
            <div class="inviteDialog-right-center" v-else>
              {{
                resData.profile.work_age
                  ? `工作${resData.profile.work_age}年`
                  : "无工作经验"
              }}<span>|</span>{{ resData.profile.education }}<span>|</span
              >{{ resData.profile.age }}岁<span>|</span
              >{{ resData.profile.gender ? "男" : "女" }}<span>|</span
              >{{ resData.profile.height }}cm
            </div>
            <div class="inviteDialog-right-bottom" v-if="type == 1">
              {{ resData.wanted_post ? resData.wanted_post.join("，") : "" }}
            </div>
            <div class="inviteDialog-right-bottom" v-else>
              {{ resData.wanted ? wantedJoin : "" }}
            </div>
          </div>
        </div>
        <div class="inviteDialog-content">
          <div v-if="status == 1">选择要邀请TA投递的在招职位：</div>
          <el-select v-model="value" placeholder="请选择" v-if="status == 1">
            <el-option
              v-for="(item, index) in postOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div v-if="status == 2" class="inviteDialog-content-dow">
            *下载简历(含联系方式)需消耗 1 份下载次数；
          </div>
          <div v-if="status == 2" class="inviteDialog-content-dow">
            *下载后，30天内可免费下载TA的最新简历；
          </div>
        </div>
        <div class="inviteDialog-footer">
          <div style="display: flex; margin-top: 2.5px">
            <div v-if="status == 1" class="dialogZD-bottom-left">
              需消耗1次邀投<span
                >/目前余{{ invite_deliver_today_surplus }}次</span
              >
            </div>
            <div v-if="status == 2" class="dialogZD-bottom-left">
              需消耗1点下载<span
                >/目前余{{ resume_download_num_surplus }}点</span
              >
            </div>
            <div class="dialogZD-bottom-left-triangle"></div>
          </div>
          <div class="dialogZD-bottom-button">
            <button
              v-if="status == 1"
              class="dialogZD-bottom-buttonL"
              @click="more"
            >
              升级次数
            </button>
            <button
              v-if="status == 1"
              class="dialogZD-bottom-buttonR"
              :disabled="invite_deliver_today_surplus < 1"
              @click="comit(1)"
            >
              邀请投递
            </button>
            <button
              v-if="status == 2"
              class="dialogZD-bottom-buttonL"
              @click="more"
            >
              去购买
            </button>
            <button
              v-if="status == 2"
              class="dialogZD-bottom-buttonR"
              :disabled="
                resData.is_download !== 1 && resume_download_num_surplus < 1
              "
              @click="comit(2)"
            >
              下载简历
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import resumeDisablog from "@/components/resumeDisablog";
import TalentCenterListItem from "$global/TalentCenterListItem";
import RightFilter from "$global/RightFilter";
import { changeFilterData } from "@/utils/pageOther";
import NoData from "$global/NoData";
import axios from "@/utils/axios";

const initTabTotal = [{ status: 0 }, { status: 1 }, { status: 2 }];

export default {
  components: {
    resumeDisablog,
    TalentCenterListItem,
    RightFilter,
    NoData,
  },
  data() {
    return {
      // 处理顶部筛选
      tabTotal: JSON.parse(JSON.stringify(initTabTotal)),
      totalName: ["同行圈人才库", "收藏人才", "近期下载"],
      selectTabTotal: 0,
      // 处理顶部切换
      // 加载
      listLoading: false,
      // 侧栏筛选数据
      // 简历列表
      resumeList: [],
      // 列表处理
      listPage: 1,
      listSize: 10,
      listTotal: 0,
      // 侧边筛选
      otherFilter: {},
      dataList: [],
      resFiSelectTag: 0,

      readonly: false,
      order_type_status1: 1,
      // 汇总信息
      talent_pool_limit: 0,
      invite_deliver_today_surplus: 0,
      resume_download_num_surplus: 0,

      //弹窗
      inviteDialog: false,
      status: 0,
      value: "",
      postOptions: [],
      resData: [],
      type: 1,
      //人才库默认选中的意向职位
      wanted_post: [],
      //人才库默认选中的城市
      wanted_city: "",
    };
  },
  created() {},
  async mounted() {
    // 调用列表数据
    let res = await this.$axios.post(
      "/recruitment/position/inprogress_list",
      {}
    );
    this.postOptions = res.data.items.map((i) => {
      if (!this.wanted_post.includes(i.type)) {
        this.wanted_post.push(i.type);
      }
      if (!this.wanted_city) {
        this.wanted_city = i.city;
      }
      return {
        label: i.post + "|" + i.project_name,
        value: i.id,
      };
    });

    if (this.selectTabTotal === 0) {
      this.loadReset();
    }

    this.getResumeList();
    this.init();
  },
  computed: {
    filterColor() {
      let color = this.resFiSelectTag ? "filter-yes" : "filter-no";
      let img = this.resFiSelectTag ? 1 : 0;
      return {
        color,
        img,
      };
    },
    dynamic() {
      let n = new Date();
      let last_visit_time = new Date(this.resData.last_visit_time);
      let res = n.getTime() - last_visit_time.getTime();
      return parseInt(res / (1000 * 60 * 60 * 24));
    },
    wantedJoin() {
      if (this.resData) {
        let dom = this.resData.wanted.map((i) => i.post);
        let domTxt = dom.join("，");
        return domTxt;
      }
      return "";
    },
  },
  methods: {
    init() {
      this.$axios
        .post("/recruitment/company/product", {})
        .then((res) => {
          if (res.data) {
            this.talent_pool_limit = res.data.member.talent_pool_limit;
            this.invite_deliver_today_surplus =
              res.data.quota.invite_deliver_day_limit_surplus;
            this.resume_download_num_surplus =
              res.data.quota.resume_download_num_surplus;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadReset() {
      //如果是人才库 默认带入
      let wanted_post = [];
      let wanted_city = "";
      if (this.selectTabTotal === 0) {
        wanted_post = this.wanted_post;
        wanted_city = this.wanted_city;
      }
      this.otherFilter = {
        wanted_post: wanted_post,
        kw: "",
        checkList: [],
        expList: [],
        project_type: [],
        time: "",
        maxAge: "",
        minAge: "",
        sexList: [],
        wanted_city: wanted_city,
      };
      this.listPage = 1;
      this.listSize = 10;
      this.listTotal = 0;
    },
    resDatad(data) {
      this.resData = data.resData;
      this.status = data.status;
      this.type = 1;
      this.inviteDialog = true;
    },
    inviteDia(data) {
      this.resData = data.resData;
      this.status = data.status;
      this.type = 2;
      this.inviteDialog = true;
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      this.listSize = val;
      this.getResumeList(undefined, undefined, true);
    },
    handleCurrentChange(val) {
      this.listPage = val;
      this.getResumeList(undefined, undefined, true);
    },
    // 获取顶部筛选
    switchTabTotal(val) {
      if (this.selectTabTotal === val) return;
      this.selectTabTotal = val;
      this.loadReset();
      this.getResumeList(undefined, undefined, true);
    },
    getResumeList(readonly, order_type_status1, goTop = false) {
      let parameter = {
        page_flag: 1,
        total_flag: 1,
        status: this.selectTabTotal,
        per_page: this.listSize,
        current_page: this.listPage,
        is_unread: readonly,
        order_type_status1: order_type_status1,
        ...changeFilterData(this.otherFilter),
      };
      this.listLoading = true;
      let url = "";
      if (this.selectTabTotal == 0) {
        url = "/recruitment/talent/list";
      } else if (this.selectTabTotal == 1) {
        url = "/recruitment/talent/like_list";
      } else if (this.selectTabTotal == 2) {
        url = "/recruitment/talent/download_list";
      }
      this.$axios
        .post(url, parameter)
        .then((res) => {
          this.dataList = res.data.items.map((val) => ({
            id: val.id,
            resume_key: val.resume_key,
          }));
          this.listTotal = res.data.paging.total;
          this.resumeList = res.data.items;
          if (goTop) {
            let dom = document.getElementsByClassName("index-content")[0];
            dom.scrollTo(0, 0);
          }

          // console.log(this.resumeList)
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    openRightFilter() {
      this.$refs.rFilter.openFilter();
    },
    getFilterData(data) {
      this.otherFilter = data;

      let newData = JSON.parse(JSON.stringify(data));

      let filterSelectTag = false;
      for (let item in newData) {
        if (newData[item].length !== 0) {
          filterSelectTag = true;
          break;
        }
      }

      this.resFiSelectTag = filterSelectTag;

      this.listPage = 1;

      this.getResumeList(undefined, undefined, true);
    },
    changeZwSelect() {
      this.getResumeList();
    },
    initFilterMore() {
      this.$refs.rFilter.initFilter();
    },
    openDetailMod(id) {
      this.$refs.dialogComponent.showDialog(id, 1);
    },
    invite(data) {
      this.init();
      // 调用列表数据
      this.getResumeList();
    },
    updateListData(flag) {
      let newData = JSON.parse(JSON.stringify(this.resumeList));
      let option = newData.findIndex((val) => val.id === flag.id);
      if (flag.name === "status") {
        newData[option].status = flag.tag;
      } else {
        newData[option].resume_like = flag.tag;
        newData[option].is_collect = flag.tag;
      }

      this.resumeList = newData;
    },
    close(data) {
      this.dialogVisible = data;
      // this.init();
      // this.getResumeList();
    },
    async comit(type) {
      if (type == 1) {
        if (1 > this.invite_deliver_today_surplus) {
          this.$message.error("今日剩余邀投次数已用完，先收藏明天再来吧");
        } else {
          if (this.value) {
            this.$axios
              .post("/recruitment/talent/invite", {
                id: this.resData.id,
                employ_id: this.value,
              })
              .then((res) => {
                this.$message.success("邀请投递成功");
                this.inviteDialog = false;
                //利用对象的引用传递本地修改导出对象状态
                this.resData.is_invite = 1;
                //层级太深 列表状态本地修改
                let item = this.resumeList.find(
                  (item) => item.id === this.resData.id
                );
                let index = this.resumeList.findIndex(
                  (item) => item.id === this.resData.id
                );
                item.is_invite = 1;
                this.resumeList.splice(index, 1, item);

                this.init();
                // this.getResumeList();
              });
          } else {
            this.$message.error("请选择邀请投递的职位");
          }
        }
      } else {
        if (
          this.resData.is_download !== 1 &&
          this.resume_download_num_surplus < 1
        ) {
          this.$message.error("剩余可用权益次数不足");
          return;
        }
        let exportParam = {
          resume_key: this.resData.resume_key,
        };
        try {
          await axios.download("/recruitment/talent/download", exportParam);
          this.$message.success("下载简历成功");
          this.inviteDialog = false;

          //利用对象的引用传递本地修改导出对象状态
          this.resData.is_download = 1;
          //层级太深 列表状态本地修改
          let item = this.resumeList.find(
            (item) => item.id === this.resData.id
          );
          let index = this.resumeList.findIndex(
            (item) => item.id === this.resData.id
          );
          item.is_download = 1;
          this.resumeList.splice(index, 1, item);
          this.init();
          // this.getResumeList();
        } catch (error) {
          console.log(error);
        }
      }
    },
    more() {
      this.$router.push("/rights");
    },
  },
};
</script>

<style lang="scss">
@import "$styles/global.scss";

.TalentCenter {
  box-sizing: border-box;
  height: 100%;
  .resume-top {
    background: #fff;
    width: 100%;
    height: 56px;
    padding: 0 20px;
    box-sizing: border-box;
    border-radius: 4px;
    margin-bottom: 10px;

    @include flex-box(space-between);

    .resume-top-left {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #3c4554;
      width: 300px;
      font-weight: bold;

      .rtl-select {
        color: $guide-color;
      }

      span {
        cursor: pointer;
      }

      .active {
        color: #4061f8;
      }
    }
  }
  .resume-top-title {
    background-color: #fbf2ec;
    padding: 0 20px;
    color: #3c4554;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    line-height: 30px;
    height: 30px;
    div {
      // width: 400px;
      display: flex;
      > span {
        margin-right: 20px;
      }
    }
    & > span {
      color: #403cf0;
      cursor: pointer;
    }
  }
  .resume-list-search {
    background-color: #fff;
    margin-top: 20px;
    display: flex;
  }

  .last-box {
    width: 100%;
    height: 35px;
    box-sizing: border-box;
    border-radius: 4px 4px 0 0;
    margin-top: 10px;
    @include flex-box(space-between);
    .filter-btn {
      font-size: 16px;
      @include flex-box();
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }

  .index-content {
    width: 100%;
    @include scroll-style();
  }
  .index-content::-webkit-scrollbar-track {
    background: none;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0) !important;
  }
  .index-content::-webkit-scrollbar-thumb {
    background: #eaedf3;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0) !important;
    border-radius: 4px;
  }
  .page-view {
    width: 100%;
    height: 50px;
    @include flex-box(flex-start);
  }
  .inviteDialog {
    .el-dialog {
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      .el-dialog__body {
        padding: 12px 15px 20px;
      }
    }
    .inviteDialog-top {
      display: flex;
      .inviteDialog-img {
        width: 72px;
        height: 72px;
        margin-top: 7px;
        margin-right: 20px;
        .el-image {
          border: 1px solid #cfd7e1;
          width: 100%;
          border-radius: 50%;
          height: 100%;
        }
      }
      .inviteDialog-right-top {
        display: flex;
        line-height: 30px;
        span {
          color: #3c4554;
          font-size: 18px;
          font-weight: bold;
        }
        button {
          padding: 6px 10px;
          border-radius: 4px;
          border: 1px solid #dae2ef;
          background-color: #fff;
          color: #888d96;
          font-size: 12px;
          margin-left: 15px;
        }
      }
      .inviteDialog-right-center {
        margin: 10px 0;
        color: #888d96;
        font-size: 14px;
        line-height: 14px;
        span {
          margin: 0 10px;
        }
      }
      .inviteDialog-right-bottom {
        color: #3c4554;
        font-size: 14px;
      }
    }
    .inviteDialog-content {
      margin-top: 35px;
      color: #303b4b;
      font-size: 16px;
      font-weight: bold;
      .inviteDialog-content-dow {
        font-size: 12px;
        font-weight: 400;
        color: #303b4b;
        line-height: 24px;
      }
      .el-select {
        margin-top: 10px;
      }
    }
    .inviteDialog-footer {
      margin-top: 41px;
      display: flex;
      justify-content: space-between;
      .dialogZD-bottom-left {
        max-width: 225px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 3px 0 10px;
        border-radius: 4px;
        height: 30px;
        line-height: 30px;
        background-color: #ffefe9;
        color: #f4771d;
        font-size: 12px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        span {
          color: #303b4b;
        }
      }
      .dialogZD-bottom-left-triangle {
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-left: 16px solid #ffefe9;
      }
      .dialogZD-bottom-button {
        button {
          padding: 8px 21px;
          border-radius: 4px;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
        .dialogZD-bottom-buttonL {
          background-color: #f4771d;
          margin-right: 10px;
        }
        .dialogZD-bottom-buttonR {
          background-color: #4061f8;
        }
      }
    }
  }
}
</style>
